import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)(({ theme }) => ({
  margin: 0,
  fontWeight: theme.typography.fontWeightMedium,
}));
